import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const CoachingServicesListing = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  return (
    <>
      <section className="suggested-coaching">
        <div className="container mt-4">
          <button className="mb-4 bck-btn" onClick={() => navigate(-1)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="17"
              viewBox="0 0 10 17"
              fill="none"
            >
              <path
                d="M7.42188 16.6262L0.273438 9.16523C0.078125 8.93086 0 8.69649 0 8.46211C0 8.2668 0.078125 8.03242 0.234375 7.83711L7.38281 0.376169C7.73438 -0.0144556 8.35938 -0.0144556 8.71094 0.337107C9.10156 0.688669 9.10156 1.27461 8.75 1.66523L2.22656 8.46211L8.78906 15.3371C9.14062 15.6887 9.14062 16.3137 8.75 16.6652C8.39844 17.0168 7.77344 17.0168 7.42188 16.6262Z"
                fill="black"
              />
            </svg>{" "}
            {t("back")}
          </button>
          <div className="row mt-5">
            <div className="col-12">
              <h3 className="mentor-title mb-0">Coaching Services</h3>
            </div>
          </div>
          <div className="councoa d-flex justify-content-start mt-5 mb-5">
            <p>Choose one or more industries to view coaching services</p>
          </div>
          <div className="row mt-5">
            <div className="col-12">
              <div className="contsection"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoachingServicesListing;
